export default __webpack_public_path__ + "static/media/AQULIFT.b4c015d1.png";